<template>
  <div class="spinner" v-if="!newsForm">
    <ProgressSpinner />
  </div>
  <div
    :class="{
      'version-controllers': true,
      'read-only': demo
    }"
  >
    <div class="version-controllers__change">
      <IndicatorDate
        name="Дата изменения"
        mark
        :disabled="!validNews || newsForm.Id === 0"
        :date="formaterDate(newsForm.DateUpdated)"
        @click-icon="showStoryChangeModal"
      />
    </div>
    <div class="version-controllers__publish">
      <IndicatorDate
        name="Дата добавления"
        :disabled="!validNews"
        :date="formaterDate(newsForm.DateCreated)"
      />
      <IndicatorDate
        name="Дата отображаемой публикации"
        calendar
        :disabled="!validNews"
        :date="formaterDate(newsForm.PublicationDate)"
        :change-date="changePublicationDate"
      />
      <IndicatorDate
        name="Дата отложенной публикации"
        calendar
        :disabled="!validNews"
        :date="formaterDate(newsForm.DefferedDate)"
        :change-date="changeDefferedDate"
      />
    </div>
  </div>

  <div class="news-constructor" v-if="newsForm">
    <span class="news-constructor__overlay" v-if="demo"/>
    <div
      :class="{
        'news-constructor__content content': true,
        'read-only': demo
      }"
    >
      <Dropdown
        v-model="newsForm.UniversalTagId"
        :options="newsForm.UniversalTags"
        option-label="Description"
        option-value="Id"
        placeholder="Направление деятельности"
        style="width: 300px;"
      />
      <span class="news-constructor__mark">*Обязательно для заполнения</span>
      <InputText
        type="text"
        v-model="newsForm.Header"
        placeholder="Заголовок"
      />
      <span class="news-constructor__mark">*Обязательно для заполнения</span>
      <Textarea
        v-model="newsForm.Synopsis"
        rows="5"
        cols="30"
        placeholder="Краткое описание"
        :auto-resize="true"
      />
      <span class="news-constructor__mark">*Обязательно для заполнения</span>
        <draggable
          v-model="newsForm.ContentBlocks"
          tag="div"
          item-key="Name"
          class="content__blocks"
          :animation="300"
        >
          <template #item="{ element }">
            <FormContentBlock
              :contentBlock="element"
              :show-check-mark="newsForm?.FrontImageFileId == element.Images[0]?.FileId"
              @on-editor-input="editorInput($event, element)"
              @click-delete="deleteContentBlock(element.Id)"
            />
          </template>
        </draggable>
      <block-adder  :function-click="addContentBlock"/>
    </div>

    <div class="news-constructor__seo seo">
      <div class="seo__wrapper">
        <div class="seo__item">
          <TagBox
            header="Теги"
            text-btn="Добавить новый тег"
            :items-arr="newsForm.InnerTags"
            type-tag="inner"
            :add-new-item="switchShowTagsModal"
          />
          <span class="news-constructor__mark">*Обязательно для заполнения</span>
        </div>
        <div class="seo__item">
          <TagBox
            header="Поисковые ключевые слова"
            text-btn="Добавить новое поисковое ключевое слово"
            :items-arr="newsForm.SearchTags"
            type-tag="search"
          />
          <span class="news-constructor__mark">*Обязательно для заполнения
            {{ policiesValid(policies, newsForm.UniversalTagId) }}
          </span>
        </div>
        <div
          class="news-constructor__controllers controllers"
          v-if="!demo"
        >
          <!-- <BaseBtn text="Посмотреть" /> -->
          <BaseBtn
            text="Сохранить"
            :disabled="!validNews || checkChange"
            @click-btn="saveNews"
          />
          <div class="controllers__item">
            <Transition name="slide-up" class="controllers__slide">
              <BaseBtn
                v-if="!newsForm.Published"
                text="Опубликовать"
                :disabled="
                  !validNews
                  ||
                  !policiesValid(policies, newsForm.UniversalTagId)
                "
                @click-btn="togglePublished(true)"
              />
              <BaseBtn
                v-else
                text="Снять с публикации"
                yellow
                :disabled="
                  !validNews
                  ||
                  !policiesValid(policies, newsForm.UniversalTagId)
                "
                @click-btn="togglePublished(false)"
              />
            </Transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import draggable from 'vuedraggable'

import { formaterDate } from '@/helpers/helpFunctions.js'
import { policiesValid } from '@/helpers/policiesValidator'

import IndicatorDate from '@/components/ui/IndicatorDate.vue'
import BlockAdder from '@/components/elements/BlockAdder.vue'
import FormContentBlock from '@/components/elements/FormContentBlock.vue'
import TagBox from '@/components/elements/TagBox.vue'
import BaseBtn from '@/components/ui/BaseBtn.vue'

import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import ProgressSpinner from 'primevue/progressspinner'

export default {
  name: 'NewsConstructor',
  components: {
    IndicatorDate,
    Dropdown,
    InputText,
    Textarea,
    BlockAdder,
    FormContentBlock,
    TagBox,
    BaseBtn,
    ProgressSpinner,
    draggable
  },
  props: {
    demo: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const store = useStore()

    // при помощи policies определяется имеет ли пользователь полномочия
    const policies = computed(() => store.getters.getPolicies)

    // объект новости
    const newsForm = computed(() => store.getters.getNewsForm)

    // глубокая копия объекта новости чтобы отcлеживать изменения
    const originNewsForm = computed(() => store.getters.getOriginNewsForm)

    // отслеживает изменения объекта новости
    const checkChange = computed(() => {
      return JSON.stringify(newsForm.value) === JSON.stringify(originNewsForm.value)
    })

    // определяет есть ли незаполненные поля из обязательных
    const validNews = computed(() => {
      switch (true) {
        case newsForm.value.UniversalTagId === 0 :
        case newsForm.value.Header === null :
        case newsForm.value.Header === '' :
        case newsForm.value.Synopsis === null:
        case newsForm.value.Synopsis === '':
          store.commit('SetValidNews', false)
          break
        default:
          store.commit('SetValidNews', true)
      }
      return store.getters.getValidNews
    })

    // добавить контент блок в новость
    const addContentBlock = (type) => {
      const obj = {
        Configuration: null,
        FilePath: null,
        Images: [],
        Modificator: null,
        Text: '',
        Type: type
      }

      switch (type) {
        case 'HyperText':
          store.commit('SetContentBlock', obj)
          store.commit('SetAddContentBlock')
          break
        case 'Image':
          store.commit('SetContentBlock', obj)
          store.commit('SetShowImageUploader', true)
          break
        case 'Video':
          store.commit('SetContentBlock', obj)
          store.commit('SetShowVideoUploader', true)
          break
      }
    }

    // удалить контент блок
    const deleteContentBlock = (val) => {
      newsForm.value.ContentBlocks = newsForm.value.ContentBlocks.filter((item) => {
        return item.Id !== val
      })
    }

    // дожидается пока новость сохранится после чего обновляет страницу с новым Id версии
    const saveNews = async () => {
      store.commit('SetNewsForm', { ...newsForm.value })
      await store.dispatch('setSaveNews')
      router.push(`/news/editor/${newsForm.value.Id}`)
    }

    // опубликовать или снть с публикации
    const togglePublished = async (val) => {
      newsForm.value.Published = val
      store.commit('SetNewsForm', { ...newsForm.value })

      await store.dispatch('setSaveNews')
      store.dispatch('setTogglePublish', val)
    }

    // получает текст из CKEditor (редактор текста)
    // и сохраняет в соответвтующий контекст блок
    const editorInput = (event, item) => {
      item.Text = event
    }

    // изменить дату публикации
    const changePublicationDate = (e, type) => {
      // возможно следует переделать чтобы при clear
      // устанавливалась текущая дата
      if (type === 'select') {
        newsForm.value.PublicationDate = e
      } else if (type === 'clear') {
        newsForm.value.PublicationDate = null
      }
    }

    // отложенная публикация а также её отмена
    const changeDefferedDate = (e, type) => {
      // эту логику надо переработать чтобы запрос срабатывал при нажатии кнопки "сохранить"
      const obj = {
        value: e
      }

      if (type === 'select') {
        newsForm.value.DefferedDate = e

        store.commit('SetNewsForm', { ...newsForm.value })

        store.dispatch('setDefferedDate', obj)
      } else if (type === 'clear') {
        obj.value = null
        newsForm.value.DefferedDate = null
        store.commit('SetNewsForm', { ...newsForm.value })
        store.dispatch('setDefferedDate', obj)
      }
    }

    // показать модалку выбора тегов и ключ слов
    const switchShowTagsModal = (val) => {
      store.commit('SetShowTagsModal', val)
    }

    // показать модалку истории изменений
    const showStoryChangeModal = () => {
      store.commit('SetShowStoryChangeModal', true)
      store.dispatch('setChangeHistory', newsForm.value.Id)
    }

    return {
      newsForm,
      checkChange,
      policies,
      policiesValid,
      addContentBlock,
      saveNews,
      editorInput,
      deleteContentBlock,
      togglePublished,
      changePublicationDate,
      changeDefferedDate,
      switchShowTagsModal,
      validNews,
      showStoryChangeModal,
      formaterDate
    }
  }
}
</script>

<style>
.p-cascadeselect {
  border: 1px solid #ced4da !important;
  padding: 10px 12px;
}
</style>

<style lang="scss" scoped>
.p-cascadeselect {
  border: 1px solid #ced4da !important;
  padding: 10px 12px;
}
.spinner {
  @include flex-center;
}

.read-only {
  pointer-events: none;
}
.version-controllers {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  &__change {
    display: flex;
    flex: 1;
  }

  &__publish {
    display: flex;
    gap: 30px;
  }
}
.news-constructor {
  position: relative;
  display: flex;
  align-items: start;
  justify-content: space-between;
  height: calc(100vh - 165px);
  padding-right: 10px;
  overflow-y: auto;

    /* Стили для скролла */
  &::-webkit-scrollbar {
    width: 8px; /* ширина для горизонтального скролла */
    background-color: rgba(192, 192, 192, 0.5);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(27, 166, 218, 0.7);

    &:hover {
      background-color: rgb(27, 166, 218);
    }
  }

  &__mark {
    margin-bottom: 8px;
    text-align: start;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: -0.02em;
    font-feature-settings: 'calt' off;
    color: #848484;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 60%;
    background-color: #FFFFFF;
  }

  &__controllers, .controllers {
    display: flex;
    justify-content: center;
    gap: 15px;

    &__item {
      position: relative;
      width: 218px;
    }

    &__slide {
      position: absolute;
      inset: 0;
    }
  }
}

.seo {
  position: sticky;
  top: 30px;
  width: 38%;
  height: 100%;

  &__item {
    height: 318px;
    margin-bottom: 30px;
  }
}

// анимация кнопки публикации и снятия с публикации
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
